/**
 * Formate un nombre en devise (XAF - Franc CFA camerounais)
 * @param amount - Le montant à formater
 * @returns Le montant formaté avec le symbole de la devise
 */
export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('fr-CM', {
    style: 'currency',
    currency: 'XAF',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};
